export default "__VITE_ASSET__d933cb1c__"